//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { BaseClient } from "./BaseClient";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ArticleClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @param articleType (optional) 
     * @param language (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, articleType: ArticleType | undefined, language: string | undefined): Promise<ArticleResponse[]> {
        let url_ = this.baseUrl + "/api/Article?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (articleType === null)
            throw new Error("The parameter 'articleType' cannot be null.");
        else if (articleType !== undefined)
            url_ += "ArticleType=" + encodeURIComponent("" + articleType) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ArticleResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: InsertArticleRequest | undefined): Promise<ArticleResponse> {
        let url_ = this.baseUrl + "/api/Article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<ArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateArticleRequest | undefined): Promise<ArticleResponse> {
        let url_ = this.baseUrl + "/api/Article";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(id: number): Promise<ArticleResponse> {
        let url_ = this.baseUrl + "/api/Article/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleResponse>(null as any);
    }

    /**
     * @return Success
     */
    remove(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Article/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param slug (optional) 
     * @param putujmoSite (optional) 
     * @param articleType (optional) 
     * @param language (optional) 
     * @return Success
     */
    getBySlug(slug: string | undefined, putujmoSite: PutujmoSite | undefined, articleType: ArticleType | undefined, language: string | undefined): Promise<ArticleResponse> {
        let url_ = this.baseUrl + "/api/Article/getBySlug?";
        if (slug === null)
            throw new Error("The parameter 'slug' cannot be null.");
        else if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "putujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (articleType === null)
            throw new Error("The parameter 'articleType' cannot be null.");
        else if (articleType !== undefined)
            url_ += "articleType=" + encodeURIComponent("" + articleType) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBySlug(_response);
        });
    }

    protected processGetBySlug(response: Response): Promise<ArticleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrders(body: UpdateArticleOrdersRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Article/updateOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrders(_response);
        });
    }

    protected processUpdateOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CategoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @param articleType (optional) 
     * @param language (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, articleType: ArticleType | undefined, language: string | undefined): Promise<CategoryResponse[]> {
        let url_ = this.baseUrl + "/api/Category?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (articleType === null)
            throw new Error("The parameter 'articleType' cannot be null.");
        else if (articleType !== undefined)
            url_ += "ArticleType=" + encodeURIComponent("" + articleType) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<CategoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: InsertCategoryRequest | undefined): Promise<CategoryResponse> {
        let url_ = this.baseUrl + "/api/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<CategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCategoryRequest | undefined): Promise<CategoryResponse> {
        let url_ = this.baseUrl + "/api/Category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(id: number): Promise<CategoryResponse> {
        let url_ = this.baseUrl + "/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CategoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryResponse>(null as any);
    }

    /**
     * @return Success
     */
    remove(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Category/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmailProxyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmail(body: EmailDataRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/EmailProxy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ForgotPasswordClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPasswordConfirm(body: ForgotPasswordConfirmRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ForgotPassword/Confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgotPasswordConfirm(_response);
        });
    }

    protected processForgotPasswordConfirm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LoginClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginRequest | undefined): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/api/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }
}

export class PackageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, language: string): Promise<PackageModel[]> {
        let url_ = this.baseUrl + "/api/Package?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PackageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PackageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PackageModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: PackageModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Package";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAllByProperty(propertyId: string, putujmoSite: PutujmoSite | undefined, language: string): Promise<PackageModel[]> {
        let url_ = this.baseUrl + "/api/Package/getAllByProperty?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined and cannot be null.");
        else
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllByProperty(_response);
        });
    }

    protected processGetAllByProperty(response: Response): Promise<PackageModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PackageModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PackageModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRange(body: PackageModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Package/inserRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertRange(_response);
        });
    }

    protected processInsertRange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PPSCardMembershipRequestClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: InsertPPSCardMembershipRequest | undefined): Promise<PPSCardMembershipRequestResponse> {
        let url_ = this.baseUrl + "/api/PPSCardMembershipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<PPSCardMembershipRequestResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PPSCardMembershipRequestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPSCardMembershipRequestResponse>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined): Promise<PPSCardMembershipRequestResponse[]> {
        let url_ = this.baseUrl + "/api/PPSCardMembershipRequest?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PPSCardMembershipRequestResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PPSCardMembershipRequestResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPSCardMembershipRequestResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    markPaid(id: number): Promise<PPSCardMembershipRequestResponse> {
        let url_ = this.baseUrl + "/api/PPSCardMembershipRequest/markPaid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkPaid(_response);
        });
    }

    protected processMarkPaid(response: Response): Promise<PPSCardMembershipRequestResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PPSCardMembershipRequestResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPSCardMembershipRequestResponse>(null as any);
    }

    /**
     * @return Success
     */
    remove(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/PPSCardMembershipRequest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PropertyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    get(propertyId: string, putujmoSite: PutujmoSite | undefined, language: string): Promise<PropertyModel> {
        let url_ = this.baseUrl + "/api/Property/single?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined and cannot be null.");
        else
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyModel>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, language: string): Promise<PropertyModel[]> {
        let url_ = this.baseUrl + "/api/Property?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<PropertyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: PropertyModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Property";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getIds(putujmoSite: PutujmoSite | undefined, language: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Property/ids?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIds(_response);
        });
    }

    protected processGetIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getAllReduced(filter: PutujmoSite | undefined): Promise<ReducedPropertyModel[]> {
        let url_ = this.baseUrl + "/api/Property/reduced?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllReduced(_response);
        });
    }

    protected processGetAllReduced(response: Response): Promise<ReducedPropertyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReducedPropertyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReducedPropertyModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRange(body: PropertyModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Property/insertRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertRange(_response);
        });
    }

    protected processInsertRange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrders(body: UpdatePropertyOrdersRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Property/updateOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateOrders(_response);
        });
    }

    protected processUpdateOrders(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    delete(putujmoSite: PutujmoSite | undefined, propertyId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Property/delete?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined and cannot be null.");
        else
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    deleteRange(filter: PropertyItemFilter[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Property/deleteRange?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            filter && filter.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "filter[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRange(_response);
        });
    }

    protected processDeleteRange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RegistrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startRegistration(body: StartRegistrationRequest | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/startRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartRegistration(_response);
        });
    }

    protected processStartRegistration(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @param email (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(putujmoSite: PutujmoSite | undefined, email: string | undefined, token: string | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/confirmEmail?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "putujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmEmail(_response);
        });
    }

    protected processConfirmEmail(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putUser(userId: number, body: PutRegistrationUserRequest | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/putUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutUser(_response);
        });
    }

    protected processPutUser(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putProperty(userId: number, body: PutPropertyRequest | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/putProperty/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutProperty(_response);
        });
    }

    protected processPutProperty(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertPropertyUnit(userId: number, body: InsertPropertyUnitRequest | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/insertPropertyUnit/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPropertyUnit(_response);
        });
    }

    protected processInsertPropertyUnit(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    removePropertyUnit(userId: number, id: number): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/removePropertyUnit/{userId}/{id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemovePropertyUnit(_response);
        });
    }

    protected processRemovePropertyUnit(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    putUserDocument(userId: number, body: PutRegistrationUserDocumentRequest | undefined): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/putUserDocument/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutUserDocument(_response);
        });
    }

    protected processPutUserDocument(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    finishRegistration(userId: number): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/finishRegistration/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFinishRegistration(_response);
        });
    }

    protected processFinishRegistration(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    getRegistrationUser(userId: number): Promise<RegistrationUserResponse> {
        let url_ = this.baseUrl + "/api/Registration/getUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRegistrationUser(_response);
        });
    }

    protected processGetRegistrationUser(response: Response): Promise<RegistrationUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @param registrationState (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, registrationState: RegistrationState | undefined): Promise<RegistrationUserResponse[]> {
        let url_ = this.baseUrl + "/api/Registration/getAll?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (registrationState === null)
            throw new Error("The parameter 'registrationState' cannot be null.");
        else if (registrationState !== undefined)
            url_ += "RegistrationState=" + encodeURIComponent("" + registrationState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<RegistrationUserResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse[]>(null as any);
    }

    /**
     * @param status (optional) 
     * @return Success
     */
    updateStatus(userId: number, status: RegistrationState | undefined): Promise<RegistrationUserResponse[]> {
        let url_ = this.baseUrl + "/api/Registration/updateStatus/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<RegistrationUserResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegistrationUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistrationUserResponse[]>(null as any);
    }

    /**
     * @return Success
     */
    deleteRegistrationUser(userId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Registration/deleteRegistrationUser/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRegistrationUser(_response);
        });
    }

    protected processDeleteRegistrationUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SimplePropertyClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAll(putujmoSite: PutujmoSite | undefined, language: string): Promise<SimplePropertyModel[]> {
        let url_ = this.baseUrl + "/api/SimpleProperty?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<SimplePropertyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimplePropertyModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimplePropertyModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: SimplePropertyModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SimpleProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getIds(putujmoSite: PutujmoSite | undefined, language: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/SimpleProperty/ids?";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIds(_response);
        });
    }

    protected processGetIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRange(body: SimplePropertyModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SimpleProperty/insertRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertRange(_response);
        });
    }

    protected processInsertRange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UnitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param putujmoSite (optional) 
     * @return Success
     */
    getAll(propertyId: string, putujmoSite: PutujmoSite | undefined, language: string): Promise<UnitModel[]> {
        let url_ = this.baseUrl + "/api/Unit?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined and cannot be null.");
        else
            url_ += "PropertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (putujmoSite === null)
            throw new Error("The parameter 'putujmoSite' cannot be null.");
        else if (putujmoSite !== undefined)
            url_ += "PutujmoSite=" + encodeURIComponent("" + putujmoSite) + "&";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "Language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UnitModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: UnitModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insertRange(body: UnitModel[] | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Unit/insertRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertRange(_response);
        });
    }

    protected processInsertRange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getAll(): Promise<ManagementUserResponse[]> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ManagementUserResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ManagementUserResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManagementUserResponse[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: InsertManagementUserRequest | undefined): Promise<ManagementUserResponse> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: Response): Promise<ManagementUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManagementUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManagementUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    get(email: string): Promise<ManagementUserResponse> {
        let url_ = this.baseUrl + "/api/User/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ManagementUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManagementUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ManagementUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    remove(email: string): Promise<void> {
        let url_ = this.baseUrl + "/api/User/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ArticleResponse implements IArticleResponse {
    id!: number;
    title!: string;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    updatedAt!: Date;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    slug!: string;
    order!: number;
    categoryIds?: number[] | undefined;

    constructor(data?: IArticleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.author = _data["author"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.content = _data["content"];
            this.language = _data["language"];
            this.investor = _data["investor"];
            this.location = _data["location"];
            this.price = _data["price"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.ppsCardType = _data["ppsCardType"];
            this.specialConditions = _data["specialConditions"];
            this.phobsPropertyId = _data["phobsPropertyId"];
            if (Array.isArray(_data["gallery"])) {
                this.gallery = [] as any;
                for (let item of _data["gallery"])
                    this.gallery!.push(item);
            }
            this.slug = _data["slug"];
            this.order = _data["order"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ArticleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["author"] = this.author;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["content"] = this.content;
        data["language"] = this.language;
        data["investor"] = this.investor;
        data["location"] = this.location;
        data["price"] = this.price;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["address"] = this.address;
        data["ppsCardType"] = this.ppsCardType;
        data["specialConditions"] = this.specialConditions;
        data["phobsPropertyId"] = this.phobsPropertyId;
        if (Array.isArray(this.gallery)) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item);
        }
        data["slug"] = this.slug;
        data["order"] = this.order;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

export interface IArticleResponse {
    id: number;
    title: string;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    updatedAt: Date;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    slug: string;
    order: number;
    categoryIds?: number[] | undefined;
}

export enum ArticleType {
    Blog = "Blog",
    HistoricalHeritage = "HistoricalHeritage",
    PPSCard = "PPSCard",
    Authenticity = "Authenticity",
}

export class CategoryResponse implements ICategoryResponse {
    id!: number;
    name!: string;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    language?: string | undefined;

    constructor(data?: ICategoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CategoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["language"] = this.language;
        return data;
    }
}

export interface ICategoryResponse {
    id: number;
    name: string;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    language?: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    oldPassword!: string;
    newPassword!: string;
    newPasswordConfirmation!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.newPasswordConfirmation = _data["newPasswordConfirmation"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["newPasswordConfirmation"] = this.newPasswordConfirmation;
        return data;
    }
}

export interface IChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}

export class EmailDataRequest implements IEmailDataRequest {
    domain!: string;
    to!: string;
    subject!: string;
    body!: string;

    constructor(data?: IEmailDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): EmailDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface IEmailDataRequest {
    domain: string;
    to: string;
    subject: string;
    body: string;
}

export class ErrorResponseModel implements IErrorResponseModel {
    errors?: { [key: string]: string; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResponseModel {
    errors?: { [key: string]: string; } | undefined;
}

export class ForgotPasswordConfirmRequest implements IForgotPasswordConfirmRequest {
    userEmail!: string;
    password!: string;
    passwordConfirmation!: string;
    token!: string;

    constructor(data?: IForgotPasswordConfirmRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.password = _data["password"];
            this.passwordConfirmation = _data["passwordConfirmation"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ForgotPasswordConfirmRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordConfirmRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["password"] = this.password;
        data["passwordConfirmation"] = this.passwordConfirmation;
        data["token"] = this.token;
        return data;
    }
}

export interface IForgotPasswordConfirmRequest {
    userEmail: string;
    password: string;
    passwordConfirmation: string;
    token: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class InsertArticleRequest implements IInsertArticleRequest {
    title?: string | undefined;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    categoryIds?: number[] | undefined;

    constructor(data?: IInsertArticleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.author = _data["author"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.investor = _data["investor"];
            this.location = _data["location"];
            this.price = _data["price"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.ppsCardType = _data["ppsCardType"];
            this.specialConditions = _data["specialConditions"];
            this.phobsPropertyId = _data["phobsPropertyId"];
            if (Array.isArray(_data["gallery"])) {
                this.gallery = [] as any;
                for (let item of _data["gallery"])
                    this.gallery!.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): InsertArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertArticleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["author"] = this.author;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["content"] = this.content;
        data["language"] = this.language;
        data["investor"] = this.investor;
        data["location"] = this.location;
        data["price"] = this.price;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["address"] = this.address;
        data["ppsCardType"] = this.ppsCardType;
        data["specialConditions"] = this.specialConditions;
        data["phobsPropertyId"] = this.phobsPropertyId;
        if (Array.isArray(this.gallery)) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data;
    }
}

export interface IInsertArticleRequest {
    title?: string | undefined;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    categoryIds?: number[] | undefined;
}

export class InsertCategoryRequest implements IInsertCategoryRequest {
    name!: string;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    language?: string | undefined;

    constructor(data?: IInsertCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): InsertCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["language"] = this.language;
        return data;
    }
}

export interface IInsertCategoryRequest {
    name: string;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    language?: string | undefined;
}

export class InsertLongStayDiscountRequest implements IInsertLongStayDiscountRequest {
    fromDays!: number;
    toDays!: number;
    discountPercentage!: number;

    constructor(data?: IInsertLongStayDiscountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDays = _data["fromDays"];
            this.toDays = _data["toDays"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): InsertLongStayDiscountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertLongStayDiscountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDays"] = this.fromDays;
        data["toDays"] = this.toDays;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface IInsertLongStayDiscountRequest {
    fromDays: number;
    toDays: number;
    discountPercentage: number;
}

export class InsertManagementUserRequest implements IInsertManagementUserRequest {
    email!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    visiblePassword!: string;
    role!: UserRoleEnum;

    constructor(data?: IInsertManagementUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.visiblePassword = _data["visiblePassword"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): InsertManagementUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertManagementUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["visiblePassword"] = this.visiblePassword;
        data["role"] = this.role;
        return data;
    }
}

export interface IInsertManagementUserRequest {
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    visiblePassword: string;
    role: UserRoleEnum;
}

export class InsertPPSCardMembershipRequest implements IInsertPPSCardMembershipRequest {
    putujmoSite!: PutujmoSite;
    firstName!: string;
    lastName!: string;
    address!: string;
    city!: string;
    phone!: string;
    email!: string;

    constructor(data?: IInsertPPSCardMembershipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): InsertPPSCardMembershipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertPPSCardMembershipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data;
    }
}

export interface IInsertPPSCardMembershipRequest {
    putujmoSite: PutujmoSite;
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    phone: string;
    email: string;
}

export class InsertPricelistChildDiscountRequest implements IInsertPricelistChildDiscountRequest {
    fromAge!: number;
    toAge!: number;
    price!: number;

    constructor(data?: IInsertPricelistChildDiscountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromAge = _data["fromAge"];
            this.toAge = _data["toAge"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): InsertPricelistChildDiscountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertPricelistChildDiscountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromAge"] = this.fromAge;
        data["toAge"] = this.toAge;
        data["price"] = this.price;
        return data;
    }
}

export interface IInsertPricelistChildDiscountRequest {
    fromAge: number;
    toAge: number;
    price: number;
}

export class InsertPricelistOccupancyRequest implements IInsertPricelistOccupancyRequest {
    numberOfAdults!: number;
    price!: number;

    constructor(data?: IInsertPricelistOccupancyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfAdults = _data["numberOfAdults"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): InsertPricelistOccupancyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertPricelistOccupancyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfAdults"] = this.numberOfAdults;
        data["price"] = this.price;
        return data;
    }
}

export interface IInsertPricelistOccupancyRequest {
    numberOfAdults: number;
    price: number;
}

export class InsertPricelistRequest implements IInsertPricelistRequest {
    standardPrice!: number;
    serviceType!: ServiceType;
    childDiscounts?: InsertPricelistChildDiscountRequest[] | undefined;
    pricelistOccupancies?: InsertPricelistOccupancyRequest[] | undefined;

    constructor(data?: IInsertPricelistRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standardPrice = _data["standardPrice"];
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["childDiscounts"])) {
                this.childDiscounts = [] as any;
                for (let item of _data["childDiscounts"])
                    this.childDiscounts!.push(InsertPricelistChildDiscountRequest.fromJS(item));
            }
            if (Array.isArray(_data["pricelistOccupancies"])) {
                this.pricelistOccupancies = [] as any;
                for (let item of _data["pricelistOccupancies"])
                    this.pricelistOccupancies!.push(InsertPricelistOccupancyRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertPricelistRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertPricelistRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standardPrice"] = this.standardPrice;
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.childDiscounts)) {
            data["childDiscounts"] = [];
            for (let item of this.childDiscounts)
                data["childDiscounts"].push(item.toJSON());
        }
        if (Array.isArray(this.pricelistOccupancies)) {
            data["pricelistOccupancies"] = [];
            for (let item of this.pricelistOccupancies)
                data["pricelistOccupancies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsertPricelistRequest {
    standardPrice: number;
    serviceType: ServiceType;
    childDiscounts?: InsertPricelistChildDiscountRequest[] | undefined;
    pricelistOccupancies?: InsertPricelistOccupancyRequest[] | undefined;
}

export class InsertPropertyUnitRequest implements IInsertPropertyUnitRequest {
    name!: string;
    description!: string;
    minCapacity!: number;
    standardCapacity!: number;
    maxCapacity!: number;
    minNumOfAdults!: number;
    maxNumOfAdults!: number;
    minNumOfChildren!: number;
    maxNumOfChildren!: number;
    maxAgefChildren!: number;
    numberOfUnits!: number;
    surfaceArea!: number;
    rentPropertyUnitType!: RentPropertyUnitType;
    minNumberOfNights!: number;
    allowOneNight!: boolean;
    priceIncreaseForOneNight!: number;
    isLocalTaxesIncluded!: boolean;
    maxYearOfChildDontPayLocalTaxes!: number;
    minYearOfChildPayLocalTaxes!: number;
    maxYearOfChildPayLocalTaxes!: number;
    childAmountPayLocalTaxes!: number;
    adultAmountPayLocalTaxes!: number;
    allowDiscountForLongStay!: boolean;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    pricelists?: InsertPricelistRequest[] | undefined;
    longStayDiscounts?: InsertLongStayDiscountRequest[] | undefined;

    constructor(data?: IInsertPropertyUnitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.minCapacity = _data["minCapacity"];
            this.standardCapacity = _data["standardCapacity"];
            this.maxCapacity = _data["maxCapacity"];
            this.minNumOfAdults = _data["minNumOfAdults"];
            this.maxNumOfAdults = _data["maxNumOfAdults"];
            this.minNumOfChildren = _data["minNumOfChildren"];
            this.maxNumOfChildren = _data["maxNumOfChildren"];
            this.maxAgefChildren = _data["maxAgefChildren"];
            this.numberOfUnits = _data["numberOfUnits"];
            this.surfaceArea = _data["surfaceArea"];
            this.rentPropertyUnitType = _data["rentPropertyUnitType"];
            this.minNumberOfNights = _data["minNumberOfNights"];
            this.allowOneNight = _data["allowOneNight"];
            this.priceIncreaseForOneNight = _data["priceIncreaseForOneNight"];
            this.isLocalTaxesIncluded = _data["isLocalTaxesIncluded"];
            this.maxYearOfChildDontPayLocalTaxes = _data["maxYearOfChildDontPayLocalTaxes"];
            this.minYearOfChildPayLocalTaxes = _data["minYearOfChildPayLocalTaxes"];
            this.maxYearOfChildPayLocalTaxes = _data["maxYearOfChildPayLocalTaxes"];
            this.childAmountPayLocalTaxes = _data["childAmountPayLocalTaxes"];
            this.adultAmountPayLocalTaxes = _data["adultAmountPayLocalTaxes"];
            this.allowDiscountForLongStay = _data["allowDiscountForLongStay"];
            this.phobsChecklist = _data["phobsChecklist"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (Array.isArray(_data["pricelists"])) {
                this.pricelists = [] as any;
                for (let item of _data["pricelists"])
                    this.pricelists!.push(InsertPricelistRequest.fromJS(item));
            }
            if (Array.isArray(_data["longStayDiscounts"])) {
                this.longStayDiscounts = [] as any;
                for (let item of _data["longStayDiscounts"])
                    this.longStayDiscounts!.push(InsertLongStayDiscountRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertPropertyUnitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertPropertyUnitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["minCapacity"] = this.minCapacity;
        data["standardCapacity"] = this.standardCapacity;
        data["maxCapacity"] = this.maxCapacity;
        data["minNumOfAdults"] = this.minNumOfAdults;
        data["maxNumOfAdults"] = this.maxNumOfAdults;
        data["minNumOfChildren"] = this.minNumOfChildren;
        data["maxNumOfChildren"] = this.maxNumOfChildren;
        data["maxAgefChildren"] = this.maxAgefChildren;
        data["numberOfUnits"] = this.numberOfUnits;
        data["surfaceArea"] = this.surfaceArea;
        data["rentPropertyUnitType"] = this.rentPropertyUnitType;
        data["minNumberOfNights"] = this.minNumberOfNights;
        data["allowOneNight"] = this.allowOneNight;
        data["priceIncreaseForOneNight"] = this.priceIncreaseForOneNight;
        data["isLocalTaxesIncluded"] = this.isLocalTaxesIncluded;
        data["maxYearOfChildDontPayLocalTaxes"] = this.maxYearOfChildDontPayLocalTaxes;
        data["minYearOfChildPayLocalTaxes"] = this.minYearOfChildPayLocalTaxes;
        data["maxYearOfChildPayLocalTaxes"] = this.maxYearOfChildPayLocalTaxes;
        data["childAmountPayLocalTaxes"] = this.childAmountPayLocalTaxes;
        data["adultAmountPayLocalTaxes"] = this.adultAmountPayLocalTaxes;
        data["allowDiscountForLongStay"] = this.allowDiscountForLongStay;
        data["phobsChecklist"] = this.phobsChecklist;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.pricelists)) {
            data["pricelists"] = [];
            for (let item of this.pricelists)
                data["pricelists"].push(item.toJSON());
        }
        if (Array.isArray(this.longStayDiscounts)) {
            data["longStayDiscounts"] = [];
            for (let item of this.longStayDiscounts)
                data["longStayDiscounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsertPropertyUnitRequest {
    name: string;
    description: string;
    minCapacity: number;
    standardCapacity: number;
    maxCapacity: number;
    minNumOfAdults: number;
    maxNumOfAdults: number;
    minNumOfChildren: number;
    maxNumOfChildren: number;
    maxAgefChildren: number;
    numberOfUnits: number;
    surfaceArea: number;
    rentPropertyUnitType: RentPropertyUnitType;
    minNumberOfNights: number;
    allowOneNight: boolean;
    priceIncreaseForOneNight: number;
    isLocalTaxesIncluded: boolean;
    maxYearOfChildDontPayLocalTaxes: number;
    minYearOfChildPayLocalTaxes: number;
    maxYearOfChildPayLocalTaxes: number;
    childAmountPayLocalTaxes: number;
    adultAmountPayLocalTaxes: number;
    allowDiscountForLongStay: boolean;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    pricelists?: InsertPricelistRequest[] | undefined;
    longStayDiscounts?: InsertLongStayDiscountRequest[] | undefined;
}

export class LoginRequest implements ILoginRequest {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    email?: string | undefined;
    password?: string | undefined;
}

export class LoginResponse implements ILoginResponse {
    token!: string;
    user?: ManagementUserResponse;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.user = _data["user"] ? ManagementUserResponse.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILoginResponse {
    token: string;
    user?: ManagementUserResponse;
}

export class LongStayDiscountResponse implements ILongStayDiscountResponse {
    id!: number;
    fromDays!: number;
    toDays!: number;
    discountPercentage!: number;

    constructor(data?: ILongStayDiscountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDays = _data["fromDays"];
            this.toDays = _data["toDays"];
            this.discountPercentage = _data["discountPercentage"];
        }
    }

    static fromJS(data: any): LongStayDiscountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LongStayDiscountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDays"] = this.fromDays;
        data["toDays"] = this.toDays;
        data["discountPercentage"] = this.discountPercentage;
        return data;
    }
}

export interface ILongStayDiscountResponse {
    id: number;
    fromDays: number;
    toDays: number;
    discountPercentage: number;
}

export class ManagementUserResponse implements IManagementUserResponse {
    userEmail!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role!: UserRoleEnum;

    constructor(data?: IManagementUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ManagementUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["role"] = this.role;
        return data;
    }
}

export interface IManagementUserResponse {
    userEmail: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role: UserRoleEnum;
}

export class PPSCardMembershipRequestResponse implements IPPSCardMembershipRequestResponse {
    id!: number;
    putujmoSite!: PutujmoSite;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    isPaid!: boolean;
    paidAt?: Date | undefined;
    createdAt!: Date;

    constructor(data?: IPPSCardMembershipRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.putujmoSite = _data["putujmoSite"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.isPaid = _data["isPaid"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PPSCardMembershipRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PPSCardMembershipRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["putujmoSite"] = this.putujmoSite;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["isPaid"] = this.isPaid;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPPSCardMembershipRequestResponse {
    id: number;
    putujmoSite: PutujmoSite;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    isPaid: boolean;
    paidAt?: Date | undefined;
    createdAt: Date;
}

export enum PPSCardType {
    Accommodation = "Accommodation",
    Activity = "Activity",
    Restaurant = "Restaurant",
}

export class PackageModel implements IPackageModel {
    putujmoSite!: PutujmoSite;
    language!: string;
    propertyId!: string;
    packageId!: string;
    content!: string;

    constructor(data?: IPackageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
            this.packageId = _data["packageId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): PackageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PackageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        data["packageId"] = this.packageId;
        data["content"] = this.content;
        return data;
    }
}

export interface IPackageModel {
    putujmoSite: PutujmoSite;
    language: string;
    propertyId: string;
    packageId: string;
    content: string;
}

export enum PackageType {
    Solo = "Solo",
    Plus = "Plus",
    Business = "Business",
    Pro = "Pro",
    Gratis = "Gratis",
}

export enum PersonalDocumentType {
    IdCard = "IdCard",
    Passport = "Passport",
}

export class PricelistChildDiscountResponse implements IPricelistChildDiscountResponse {
    id!: number;
    fromAge!: number;
    toAge!: number;
    price!: number;

    constructor(data?: IPricelistChildDiscountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromAge = _data["fromAge"];
            this.toAge = _data["toAge"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): PricelistChildDiscountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricelistChildDiscountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromAge"] = this.fromAge;
        data["toAge"] = this.toAge;
        data["price"] = this.price;
        return data;
    }
}

export interface IPricelistChildDiscountResponse {
    id: number;
    fromAge: number;
    toAge: number;
    price: number;
}

export class PricelistOccupancyResponse implements IPricelistOccupancyResponse {
    id!: number;
    numberOfAdults!: number;
    price!: number;

    constructor(data?: IPricelistOccupancyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfAdults = _data["numberOfAdults"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): PricelistOccupancyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricelistOccupancyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfAdults"] = this.numberOfAdults;
        data["price"] = this.price;
        return data;
    }
}

export interface IPricelistOccupancyResponse {
    id: number;
    numberOfAdults: number;
    price: number;
}

export class PricelistResponse implements IPricelistResponse {
    id!: number;
    standardPrice!: number;
    serviceType!: ServiceType;
    childDiscounts?: PricelistChildDiscountResponse[] | undefined;
    pricelistOccupancies?: PricelistOccupancyResponse[] | undefined;

    constructor(data?: IPricelistResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.standardPrice = _data["standardPrice"];
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["childDiscounts"])) {
                this.childDiscounts = [] as any;
                for (let item of _data["childDiscounts"])
                    this.childDiscounts!.push(PricelistChildDiscountResponse.fromJS(item));
            }
            if (Array.isArray(_data["pricelistOccupancies"])) {
                this.pricelistOccupancies = [] as any;
                for (let item of _data["pricelistOccupancies"])
                    this.pricelistOccupancies!.push(PricelistOccupancyResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PricelistResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PricelistResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["standardPrice"] = this.standardPrice;
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.childDiscounts)) {
            data["childDiscounts"] = [];
            for (let item of this.childDiscounts)
                data["childDiscounts"].push(item.toJSON());
        }
        if (Array.isArray(this.pricelistOccupancies)) {
            data["pricelistOccupancies"] = [];
            for (let item of this.pricelistOccupancies)
                data["pricelistOccupancies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPricelistResponse {
    id: number;
    standardPrice: number;
    serviceType: ServiceType;
    childDiscounts?: PricelistChildDiscountResponse[] | undefined;
    pricelistOccupancies?: PricelistOccupancyResponse[] | undefined;
}

export class PropertyItemFilter implements IPropertyItemFilter {
    putujmoSite!: PutujmoSite;
    language!: string;
    propertyId!: string;

    constructor(data?: IPropertyItemFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): PropertyItemFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyItemFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IPropertyItemFilter {
    putujmoSite: PutujmoSite;
    language: string;
    propertyId: string;
}

export class PropertyModel implements IPropertyModel {
    language!: string;
    propertyId!: string;
    putujmoSite!: PutujmoSite;
    content!: string;
    hasPrice!: boolean;

    constructor(data?: IPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
            this.putujmoSite = _data["putujmoSite"];
            this.content = _data["content"];
            this.hasPrice = _data["hasPrice"];
        }
    }

    static fromJS(data: any): PropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        data["putujmoSite"] = this.putujmoSite;
        data["content"] = this.content;
        data["hasPrice"] = this.hasPrice;
        return data;
    }
}

export interface IPropertyModel {
    language: string;
    propertyId: string;
    putujmoSite: PutujmoSite;
    content: string;
    hasPrice: boolean;
}

export class PropertyResponse implements IPropertyResponse {
    propertyName?: string | undefined;
    propertyAddress?: string | undefined;
    propertyCity?: string | undefined;
    propertyZipcode?: string | undefined;
    isPropertyCategorized!: boolean;
    propertyCategorizationNumber?: string | undefined;
    propertyCategorizationIssuer?: string | undefined;
    propertyCategorizationRank?: number | undefined;
    propertyUnitNumber!: PropertyUnitNumber;
    checkIn!: number;
    checkOut!: number;
    reservationEmail?: string | undefined;
    reservationPhone?: string | undefined;
    website?: string | undefined;
    facebookPage?: string | undefined;
    instagramPage?: string | undefined;
    latitude!: number;
    longitude!: number;
    description?: string | undefined;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    units?: PropertyUnitResponse[] | undefined;

    constructor(data?: IPropertyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyAddress = _data["propertyAddress"];
            this.propertyCity = _data["propertyCity"];
            this.propertyZipcode = _data["propertyZipcode"];
            this.isPropertyCategorized = _data["isPropertyCategorized"];
            this.propertyCategorizationNumber = _data["propertyCategorizationNumber"];
            this.propertyCategorizationIssuer = _data["propertyCategorizationIssuer"];
            this.propertyCategorizationRank = _data["propertyCategorizationRank"];
            this.propertyUnitNumber = _data["propertyUnitNumber"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.reservationEmail = _data["reservationEmail"];
            this.reservationPhone = _data["reservationPhone"];
            this.website = _data["website"];
            this.facebookPage = _data["facebookPage"];
            this.instagramPage = _data["instagramPage"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.description = _data["description"];
            this.phobsChecklist = _data["phobsChecklist"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(PropertyUnitResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyAddress"] = this.propertyAddress;
        data["propertyCity"] = this.propertyCity;
        data["propertyZipcode"] = this.propertyZipcode;
        data["isPropertyCategorized"] = this.isPropertyCategorized;
        data["propertyCategorizationNumber"] = this.propertyCategorizationNumber;
        data["propertyCategorizationIssuer"] = this.propertyCategorizationIssuer;
        data["propertyCategorizationRank"] = this.propertyCategorizationRank;
        data["propertyUnitNumber"] = this.propertyUnitNumber;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["reservationEmail"] = this.reservationEmail;
        data["reservationPhone"] = this.reservationPhone;
        data["website"] = this.website;
        data["facebookPage"] = this.facebookPage;
        data["instagramPage"] = this.instagramPage;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["description"] = this.description;
        data["phobsChecklist"] = this.phobsChecklist;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyResponse {
    propertyName?: string | undefined;
    propertyAddress?: string | undefined;
    propertyCity?: string | undefined;
    propertyZipcode?: string | undefined;
    isPropertyCategorized: boolean;
    propertyCategorizationNumber?: string | undefined;
    propertyCategorizationIssuer?: string | undefined;
    propertyCategorizationRank?: number | undefined;
    propertyUnitNumber: PropertyUnitNumber;
    checkIn: number;
    checkOut: number;
    reservationEmail?: string | undefined;
    reservationPhone?: string | undefined;
    website?: string | undefined;
    facebookPage?: string | undefined;
    instagramPage?: string | undefined;
    latitude: number;
    longitude: number;
    description?: string | undefined;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    units?: PropertyUnitResponse[] | undefined;
}

export enum PropertyUnitNumber {
    One = "One",
    Two = "Two",
    Three = "Three",
    Four = "Four",
    Five = "Five",
    Six = "Six",
    Seven = "Seven",
    Eight = "Eight",
    Nine = "Nine",
    Ten = "Ten",
    ElevenPlus = "ElevenPlus",
}

export class PropertyUnitResponse implements IPropertyUnitResponse {
    id!: number;
    name!: string;
    description!: string;
    minCapacity!: number;
    standardCapacity!: number;
    maxCapacity!: number;
    minNumOfAdults!: number;
    maxNumOfAdults!: number;
    minNumOfChildren!: number;
    maxNumOfChildren!: number;
    maxAgefChildren!: number;
    numberOfUnits!: number;
    surfaceArea!: number;
    rentPropertyUnitType!: RentPropertyUnitType;
    minNumberOfNights!: number;
    allowOneNight!: boolean;
    priceIncreaseForOneNight!: number;
    isLocalTaxesIncluded!: boolean;
    maxYearOfChildDontPayLocalTaxes!: number;
    minYearOfChildPayLocalTaxes!: number;
    maxYearOfChildPayLocalTaxes!: number;
    childAmountPayLocalTaxes!: number;
    adultAmountPayLocalTaxes!: number;
    allowDiscountForLongStay!: boolean;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    pricelists?: PricelistResponse[] | undefined;
    longStayDiscounts?: LongStayDiscountResponse[] | undefined;

    constructor(data?: IPropertyUnitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.minCapacity = _data["minCapacity"];
            this.standardCapacity = _data["standardCapacity"];
            this.maxCapacity = _data["maxCapacity"];
            this.minNumOfAdults = _data["minNumOfAdults"];
            this.maxNumOfAdults = _data["maxNumOfAdults"];
            this.minNumOfChildren = _data["minNumOfChildren"];
            this.maxNumOfChildren = _data["maxNumOfChildren"];
            this.maxAgefChildren = _data["maxAgefChildren"];
            this.numberOfUnits = _data["numberOfUnits"];
            this.surfaceArea = _data["surfaceArea"];
            this.rentPropertyUnitType = _data["rentPropertyUnitType"];
            this.minNumberOfNights = _data["minNumberOfNights"];
            this.allowOneNight = _data["allowOneNight"];
            this.priceIncreaseForOneNight = _data["priceIncreaseForOneNight"];
            this.isLocalTaxesIncluded = _data["isLocalTaxesIncluded"];
            this.maxYearOfChildDontPayLocalTaxes = _data["maxYearOfChildDontPayLocalTaxes"];
            this.minYearOfChildPayLocalTaxes = _data["minYearOfChildPayLocalTaxes"];
            this.maxYearOfChildPayLocalTaxes = _data["maxYearOfChildPayLocalTaxes"];
            this.childAmountPayLocalTaxes = _data["childAmountPayLocalTaxes"];
            this.adultAmountPayLocalTaxes = _data["adultAmountPayLocalTaxes"];
            this.allowDiscountForLongStay = _data["allowDiscountForLongStay"];
            this.phobsChecklist = _data["phobsChecklist"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            if (Array.isArray(_data["pricelists"])) {
                this.pricelists = [] as any;
                for (let item of _data["pricelists"])
                    this.pricelists!.push(PricelistResponse.fromJS(item));
            }
            if (Array.isArray(_data["longStayDiscounts"])) {
                this.longStayDiscounts = [] as any;
                for (let item of _data["longStayDiscounts"])
                    this.longStayDiscounts!.push(LongStayDiscountResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyUnitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyUnitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["minCapacity"] = this.minCapacity;
        data["standardCapacity"] = this.standardCapacity;
        data["maxCapacity"] = this.maxCapacity;
        data["minNumOfAdults"] = this.minNumOfAdults;
        data["maxNumOfAdults"] = this.maxNumOfAdults;
        data["minNumOfChildren"] = this.minNumOfChildren;
        data["maxNumOfChildren"] = this.maxNumOfChildren;
        data["maxAgefChildren"] = this.maxAgefChildren;
        data["numberOfUnits"] = this.numberOfUnits;
        data["surfaceArea"] = this.surfaceArea;
        data["rentPropertyUnitType"] = this.rentPropertyUnitType;
        data["minNumberOfNights"] = this.minNumberOfNights;
        data["allowOneNight"] = this.allowOneNight;
        data["priceIncreaseForOneNight"] = this.priceIncreaseForOneNight;
        data["isLocalTaxesIncluded"] = this.isLocalTaxesIncluded;
        data["maxYearOfChildDontPayLocalTaxes"] = this.maxYearOfChildDontPayLocalTaxes;
        data["minYearOfChildPayLocalTaxes"] = this.minYearOfChildPayLocalTaxes;
        data["maxYearOfChildPayLocalTaxes"] = this.maxYearOfChildPayLocalTaxes;
        data["childAmountPayLocalTaxes"] = this.childAmountPayLocalTaxes;
        data["adultAmountPayLocalTaxes"] = this.adultAmountPayLocalTaxes;
        data["allowDiscountForLongStay"] = this.allowDiscountForLongStay;
        data["phobsChecklist"] = this.phobsChecklist;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        if (Array.isArray(this.pricelists)) {
            data["pricelists"] = [];
            for (let item of this.pricelists)
                data["pricelists"].push(item.toJSON());
        }
        if (Array.isArray(this.longStayDiscounts)) {
            data["longStayDiscounts"] = [];
            for (let item of this.longStayDiscounts)
                data["longStayDiscounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyUnitResponse {
    id: number;
    name: string;
    description: string;
    minCapacity: number;
    standardCapacity: number;
    maxCapacity: number;
    minNumOfAdults: number;
    maxNumOfAdults: number;
    minNumOfChildren: number;
    maxNumOfChildren: number;
    maxAgefChildren: number;
    numberOfUnits: number;
    surfaceArea: number;
    rentPropertyUnitType: RentPropertyUnitType;
    minNumberOfNights: number;
    allowOneNight: boolean;
    priceIncreaseForOneNight: number;
    isLocalTaxesIncluded: boolean;
    maxYearOfChildDontPayLocalTaxes: number;
    minYearOfChildPayLocalTaxes: number;
    maxYearOfChildPayLocalTaxes: number;
    childAmountPayLocalTaxes: number;
    adultAmountPayLocalTaxes: number;
    allowDiscountForLongStay: boolean;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
    pricelists?: PricelistResponse[] | undefined;
    longStayDiscounts?: LongStayDiscountResponse[] | undefined;
}

export class PutPropertyRequest implements IPutPropertyRequest {
    propertyName?: string | undefined;
    propertyAddress?: string | undefined;
    propertyCity?: string | undefined;
    propertyZipcode?: string | undefined;
    checkIn!: number;
    checkOut!: number;
    isPropertyCategorized!: boolean;
    propertyCategorizationNumber?: string | undefined;
    propertyCategorizationIssuer?: string | undefined;
    propertyCategorizationRank?: number | undefined;
    propertyUnitNumber!: PropertyUnitNumber;
    reservationEmail?: string | undefined;
    reservationPhone?: string | undefined;
    website?: string | undefined;
    facebookPage?: string | undefined;
    instagramPage?: string | undefined;
    latitude!: number;
    longitude!: number;
    description?: string | undefined;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;

    constructor(data?: IPutPropertyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyAddress = _data["propertyAddress"];
            this.propertyCity = _data["propertyCity"];
            this.propertyZipcode = _data["propertyZipcode"];
            this.checkIn = _data["checkIn"];
            this.checkOut = _data["checkOut"];
            this.isPropertyCategorized = _data["isPropertyCategorized"];
            this.propertyCategorizationNumber = _data["propertyCategorizationNumber"];
            this.propertyCategorizationIssuer = _data["propertyCategorizationIssuer"];
            this.propertyCategorizationRank = _data["propertyCategorizationRank"];
            this.propertyUnitNumber = _data["propertyUnitNumber"];
            this.reservationEmail = _data["reservationEmail"];
            this.reservationPhone = _data["reservationPhone"];
            this.website = _data["website"];
            this.facebookPage = _data["facebookPage"];
            this.instagramPage = _data["instagramPage"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.description = _data["description"];
            this.phobsChecklist = _data["phobsChecklist"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): PutPropertyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PutPropertyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyAddress"] = this.propertyAddress;
        data["propertyCity"] = this.propertyCity;
        data["propertyZipcode"] = this.propertyZipcode;
        data["checkIn"] = this.checkIn;
        data["checkOut"] = this.checkOut;
        data["isPropertyCategorized"] = this.isPropertyCategorized;
        data["propertyCategorizationNumber"] = this.propertyCategorizationNumber;
        data["propertyCategorizationIssuer"] = this.propertyCategorizationIssuer;
        data["propertyCategorizationRank"] = this.propertyCategorizationRank;
        data["propertyUnitNumber"] = this.propertyUnitNumber;
        data["reservationEmail"] = this.reservationEmail;
        data["reservationPhone"] = this.reservationPhone;
        data["website"] = this.website;
        data["facebookPage"] = this.facebookPage;
        data["instagramPage"] = this.instagramPage;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["description"] = this.description;
        data["phobsChecklist"] = this.phobsChecklist;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IPutPropertyRequest {
    propertyName?: string | undefined;
    propertyAddress?: string | undefined;
    propertyCity?: string | undefined;
    propertyZipcode?: string | undefined;
    checkIn: number;
    checkOut: number;
    isPropertyCategorized: boolean;
    propertyCategorizationNumber?: string | undefined;
    propertyCategorizationIssuer?: string | undefined;
    propertyCategorizationRank?: number | undefined;
    propertyUnitNumber: PropertyUnitNumber;
    reservationEmail?: string | undefined;
    reservationPhone?: string | undefined;
    website?: string | undefined;
    facebookPage?: string | undefined;
    instagramPage?: string | undefined;
    latitude: number;
    longitude: number;
    description?: string | undefined;
    phobsChecklist?: string | undefined;
    images?: string[] | undefined;
}

export class PutRegistrationUserDocumentRequest implements IPutRegistrationUserDocumentRequest {
    personalDocumentType!: PersonalDocumentType;
    personalDocumentNumber?: string | undefined;
    personalDocumentImages?: string[] | undefined;

    constructor(data?: IPutRegistrationUserDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalDocumentType = _data["personalDocumentType"];
            this.personalDocumentNumber = _data["personalDocumentNumber"];
            if (Array.isArray(_data["personalDocumentImages"])) {
                this.personalDocumentImages = [] as any;
                for (let item of _data["personalDocumentImages"])
                    this.personalDocumentImages!.push(item);
            }
        }
    }

    static fromJS(data: any): PutRegistrationUserDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PutRegistrationUserDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalDocumentType"] = this.personalDocumentType;
        data["personalDocumentNumber"] = this.personalDocumentNumber;
        if (Array.isArray(this.personalDocumentImages)) {
            data["personalDocumentImages"] = [];
            for (let item of this.personalDocumentImages)
                data["personalDocumentImages"].push(item);
        }
        return data;
    }
}

export interface IPutRegistrationUserDocumentRequest {
    personalDocumentType: PersonalDocumentType;
    personalDocumentNumber?: string | undefined;
    personalDocumentImages?: string[] | undefined;
}

export class PutRegistrationUserRequest implements IPutRegistrationUserRequest {
    userType!: RegisteredUserType;
    hasBookingAd!: boolean;
    contractorName?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    isVat!: boolean;

    constructor(data?: IPutRegistrationUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userType = _data["userType"];
            this.hasBookingAd = _data["hasBookingAd"];
            this.contractorName = _data["contractorName"];
            this.mb = _data["mb"];
            this.pib = _data["pib"];
            this.isVat = _data["isVat"];
        }
    }

    static fromJS(data: any): PutRegistrationUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PutRegistrationUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userType"] = this.userType;
        data["hasBookingAd"] = this.hasBookingAd;
        data["contractorName"] = this.contractorName;
        data["mb"] = this.mb;
        data["pib"] = this.pib;
        data["isVat"] = this.isVat;
        return data;
    }
}

export interface IPutRegistrationUserRequest {
    userType: RegisteredUserType;
    hasBookingAd: boolean;
    contractorName?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    isVat: boolean;
}

export enum PutujmoSite {
    Serbia = "Serbia",
    Montenegro = "Montenegro",
    OnlineRezervacije = "OnlineRezervacije",
}

export class ReducedPropertyModel implements IReducedPropertyModel {
    language!: string;
    propertyId!: string;

    constructor(data?: IReducedPropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): ReducedPropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReducedPropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IReducedPropertyModel {
    language: string;
    propertyId: string;
}

export enum RegisteredUserType {
    Individiual = "Individiual",
    Entrepreneur = "Entrepreneur",
    LEgalEntity = "LEgalEntity",
}

export enum RegistrationState {
    RegistrationStarted = "RegistrationStarted",
    EmailConfirmed = "EmailConfirmed",
    WaitingForPayment = "WaitingForPayment",
    New = "New",
    Live = "Live",
    Archived = "Archived",
}

export class RegistrationUserResponse implements IRegistrationUserResponse {
    id!: number;
    putujmoSite!: PutujmoSite;
    lastUpdated!: Date;
    registrationFinished!: Date;
    email!: string;
    userType!: RegisteredUserType;
    state!: RegistrationState;
    packageType!: PackageType;
    isTrial!: boolean;
    registerWithWebsite!: boolean;
    registerWithOnlineBookingForm!: boolean;
    firstName!: string;
    lastName!: string;
    phone!: string;
    hasBookingAd!: boolean;
    personalDocumentType!: PersonalDocumentType;
    personalDocumentNumber?: string | undefined;
    personalDocumentImages?: string[] | undefined;
    contractorName?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    isVat!: boolean;
    property?: PropertyResponse;

    constructor(data?: IRegistrationUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.putujmoSite = _data["putujmoSite"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.registrationFinished = _data["registrationFinished"] ? new Date(_data["registrationFinished"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.userType = _data["userType"];
            this.state = _data["state"];
            this.packageType = _data["packageType"];
            this.isTrial = _data["isTrial"];
            this.registerWithWebsite = _data["registerWithWebsite"];
            this.registerWithOnlineBookingForm = _data["registerWithOnlineBookingForm"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.hasBookingAd = _data["hasBookingAd"];
            this.personalDocumentType = _data["personalDocumentType"];
            this.personalDocumentNumber = _data["personalDocumentNumber"];
            if (Array.isArray(_data["personalDocumentImages"])) {
                this.personalDocumentImages = [] as any;
                for (let item of _data["personalDocumentImages"])
                    this.personalDocumentImages!.push(item);
            }
            this.contractorName = _data["contractorName"];
            this.mb = _data["mb"];
            this.pib = _data["pib"];
            this.isVat = _data["isVat"];
            this.property = _data["property"] ? PropertyResponse.fromJS(_data["property"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegistrationUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["putujmoSite"] = this.putujmoSite;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["registrationFinished"] = this.registrationFinished ? this.registrationFinished.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["userType"] = this.userType;
        data["state"] = this.state;
        data["packageType"] = this.packageType;
        data["isTrial"] = this.isTrial;
        data["registerWithWebsite"] = this.registerWithWebsite;
        data["registerWithOnlineBookingForm"] = this.registerWithOnlineBookingForm;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["hasBookingAd"] = this.hasBookingAd;
        data["personalDocumentType"] = this.personalDocumentType;
        data["personalDocumentNumber"] = this.personalDocumentNumber;
        if (Array.isArray(this.personalDocumentImages)) {
            data["personalDocumentImages"] = [];
            for (let item of this.personalDocumentImages)
                data["personalDocumentImages"].push(item);
        }
        data["contractorName"] = this.contractorName;
        data["mb"] = this.mb;
        data["pib"] = this.pib;
        data["isVat"] = this.isVat;
        data["property"] = this.property ? this.property.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRegistrationUserResponse {
    id: number;
    putujmoSite: PutujmoSite;
    lastUpdated: Date;
    registrationFinished: Date;
    email: string;
    userType: RegisteredUserType;
    state: RegistrationState;
    packageType: PackageType;
    isTrial: boolean;
    registerWithWebsite: boolean;
    registerWithOnlineBookingForm: boolean;
    firstName: string;
    lastName: string;
    phone: string;
    hasBookingAd: boolean;
    personalDocumentType: PersonalDocumentType;
    personalDocumentNumber?: string | undefined;
    personalDocumentImages?: string[] | undefined;
    contractorName?: string | undefined;
    mb?: string | undefined;
    pib?: string | undefined;
    isVat: boolean;
    property?: PropertyResponse;
}

export enum RentPropertyUnitType {
    PerUnit = "PerUnit",
    PerOccupancy = "PerOccupancy",
}

export enum ServiceType {
    BedOnly = "BedOnly",
    BB = "BB",
    HB = "HB",
    FB = "FB",
    AllInc = "AllInc",
}

export class SimplePropertyModel implements ISimplePropertyModel {
    language!: string;
    propertyId!: string;
    putujmoSite!: PutujmoSite;
    content!: string;
    hasPrice!: boolean;

    constructor(data?: ISimplePropertyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
            this.putujmoSite = _data["putujmoSite"];
            this.content = _data["content"];
            this.hasPrice = _data["hasPrice"];
        }
    }

    static fromJS(data: any): SimplePropertyModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimplePropertyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        data["putujmoSite"] = this.putujmoSite;
        data["content"] = this.content;
        data["hasPrice"] = this.hasPrice;
        return data;
    }
}

export interface ISimplePropertyModel {
    language: string;
    propertyId: string;
    putujmoSite: PutujmoSite;
    content: string;
    hasPrice: boolean;
}

export class StartRegistrationRequest implements IStartRegistrationRequest {
    putujmoSite!: PutujmoSite;
    email!: string;
    firstName!: string;
    lastName!: string;
    phone!: string;
    packageType!: PackageType;
    isTrial!: boolean;
    registerWithWebsite!: boolean;
    registerWithOnlineBookingForm!: boolean;

    constructor(data?: IStartRegistrationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.packageType = _data["packageType"];
            this.isTrial = _data["isTrial"];
            this.registerWithWebsite = _data["registerWithWebsite"];
            this.registerWithOnlineBookingForm = _data["registerWithOnlineBookingForm"];
        }
    }

    static fromJS(data: any): StartRegistrationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartRegistrationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["packageType"] = this.packageType;
        data["isTrial"] = this.isTrial;
        data["registerWithWebsite"] = this.registerWithWebsite;
        data["registerWithOnlineBookingForm"] = this.registerWithOnlineBookingForm;
        return data;
    }
}

export interface IStartRegistrationRequest {
    putujmoSite: PutujmoSite;
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    packageType: PackageType;
    isTrial: boolean;
    registerWithWebsite: boolean;
    registerWithOnlineBookingForm: boolean;
}

export class UnitModel implements IUnitModel {
    putujmoSite!: PutujmoSite;
    language!: string;
    propertyId!: string;
    unitId!: string;
    content!: string;

    constructor(data?: IUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            this.language = _data["language"];
            this.propertyId = _data["propertyId"];
            this.unitId = _data["unitId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        data["language"] = this.language;
        data["propertyId"] = this.propertyId;
        data["unitId"] = this.unitId;
        data["content"] = this.content;
        return data;
    }
}

export interface IUnitModel {
    putujmoSite: PutujmoSite;
    language: string;
    propertyId: string;
    unitId: string;
    content: string;
}

export class UpdateArticleOrdersRequest implements IUpdateArticleOrdersRequest {
    orders?: UpdateSingleArticleOrderRequest[] | undefined;

    constructor(data?: IUpdateArticleOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(UpdateSingleArticleOrderRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateArticleOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateArticleOrdersRequest {
    orders?: UpdateSingleArticleOrderRequest[] | undefined;
}

export class UpdateArticleRequest implements IUpdateArticleRequest {
    title?: string | undefined;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    categoryIds?: number[] | undefined;
    id!: number;

    constructor(data?: IUpdateArticleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.imageUrl = _data["imageUrl"];
            this.author = _data["author"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.content = _data["content"];
            this.language = _data["language"];
            this.investor = _data["investor"];
            this.location = _data["location"];
            this.price = _data["price"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.ppsCardType = _data["ppsCardType"];
            this.specialConditions = _data["specialConditions"];
            this.phobsPropertyId = _data["phobsPropertyId"];
            if (Array.isArray(_data["gallery"])) {
                this.gallery = [] as any;
                for (let item of _data["gallery"])
                    this.gallery!.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateArticleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["imageUrl"] = this.imageUrl;
        data["author"] = this.author;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["content"] = this.content;
        data["language"] = this.language;
        data["investor"] = this.investor;
        data["location"] = this.location;
        data["price"] = this.price;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["website"] = this.website;
        data["address"] = this.address;
        data["ppsCardType"] = this.ppsCardType;
        data["specialConditions"] = this.specialConditions;
        data["phobsPropertyId"] = this.phobsPropertyId;
        if (Array.isArray(this.gallery)) {
            data["gallery"] = [];
            for (let item of this.gallery)
                data["gallery"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateArticleRequest {
    title?: string | undefined;
    imageUrl?: string | undefined;
    author?: string | undefined;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    content?: string | undefined;
    language?: string | undefined;
    investor?: string | undefined;
    location?: string | undefined;
    price?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    ppsCardType?: PPSCardType;
    specialConditions?: string | undefined;
    phobsPropertyId?: string | undefined;
    gallery?: string[] | undefined;
    categoryIds?: number[] | undefined;
    id: number;
}

export class UpdateCategoryRequest implements IUpdateCategoryRequest {
    name!: string;
    putujmoSite!: PutujmoSite;
    articleType!: ArticleType;
    language?: string | undefined;
    id!: number;

    constructor(data?: IUpdateCategoryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.putujmoSite = _data["putujmoSite"];
            this.articleType = _data["articleType"];
            this.language = _data["language"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCategoryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["putujmoSite"] = this.putujmoSite;
        data["articleType"] = this.articleType;
        data["language"] = this.language;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateCategoryRequest {
    name: string;
    putujmoSite: PutujmoSite;
    articleType: ArticleType;
    language?: string | undefined;
    id: number;
}

export class UpdatePropertyOrdersRequest implements IUpdatePropertyOrdersRequest {
    putujmoSite!: PutujmoSite;
    orders?: UpdateSinglePropertyOrderRequest[] | undefined;

    constructor(data?: IUpdatePropertyOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putujmoSite = _data["putujmoSite"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(UpdateSinglePropertyOrderRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePropertyOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePropertyOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["putujmoSite"] = this.putujmoSite;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePropertyOrdersRequest {
    putujmoSite: PutujmoSite;
    orders?: UpdateSinglePropertyOrderRequest[] | undefined;
}

export class UpdateSingleArticleOrderRequest implements IUpdateSingleArticleOrderRequest {
    articleId!: number;
    order!: number;

    constructor(data?: IUpdateSingleArticleOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateSingleArticleOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSingleArticleOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateSingleArticleOrderRequest {
    articleId: number;
    order: number;
}

export class UpdateSinglePropertyOrderRequest implements IUpdateSinglePropertyOrderRequest {
    propertyId!: string;
    order!: number;

    constructor(data?: IUpdateSinglePropertyOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateSinglePropertyOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSinglePropertyOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateSinglePropertyOrderRequest {
    propertyId: string;
    order: number;
}

export enum UserRoleEnum {
    SuperAdmin = "SuperAdmin",
    Admin = "Admin",
    Operator = "Operator",
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}